import { render, staticRenderFns } from "./planAttachInfo.vue?vue&type=template&id=733618e0"
import script from "./planAttachInfo.vue?vue&type=script&lang=js"
export * from "./planAttachInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports